import { render, staticRenderFns } from "./DeveloperRules.vue?vue&type=template&id=0561959e&scoped=true"
import script from "./DeveloperRules.vue?vue&type=script&lang=js"
export * from "./DeveloperRules.vue?vue&type=script&lang=js"
import style0 from "./DeveloperRules.vue?vue&type=style&index=0&id=0561959e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0561959e",
  null
  
)

export default component.exports